import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => (
  <FormattedMessage
    id="account.signup.password-invalid"
    defaultMessage="Use minimum 8 characters"
  />
);
